import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-side-settings',
  templateUrl: './side-settings.component.html',
  styleUrls: ['./side-settings.component.scss'],
})
export class SideSettingsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
